import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import i18n from 'i18n';
import {
  calculateExchangeRequest,
  createExchangeQuoteRequest,
  createExchangeTransactionRequest
} from 'services/requestAgent';

class ExchangeTransactionsStore {
  isLoadingQuote = false;
  isLoadingCalculate = false;
  isLoading = false;
  quote = null;
  calculation = null;
  error = null;
  isNewExchangeTransactionCreated = false;
  newTransactionId = null;

  constructor() {
    makeAutoObservable(this);
  }

  resetExchangeTransactionsStore = () => {
    this.isLoadingQuote = false;
    this.isLoadingCalculate = false;
    this.isLoading = false;
    this.quote = null;
    this.calculation = null;
    this.error = null;
    this.isNewExchangeTransactionCreated = false;
    this.newTransactionId = null;
  };

  resetQuote = () => {
    this.quote = null;
    this.calculation = null;
    this.error = null;
  };

  setIsNewExchangeTransactionCreated = (status) => {
    this.isNewExchangeTransactionCreated = status;
  };

  createQuote = async (accountNumber, walletFrom, walletTo) => {
    this.isLoadingQuote = true;
    this.quote = null;
    this.calculation = null;
    this.error = null;

    try {
      const quote = await createExchangeQuoteRequest(accountNumber, { walletFrom, walletTo });

      runInAction(() => {
        this.quote = quote;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err;
      });
    } finally {
      runInAction(() => {
        this.isLoadingQuote = false;
      });
    }
  };

  calculate = async (accountNumber, quoteId, amount, direction) => {
    this.isLoadingCalculate = true;
    this.error = null;

    try {
      const calculation = await calculateExchangeRequest(accountNumber, { quoteId, amount, direction });

      runInAction(() => {
        this.calculation = calculation;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err;
        this.calculation = null;
      });
    } finally {
      runInAction(() => {
        this.isLoadingCalculate = false;
      });
    }
  };

  createExchange = async (accountNumber, quoteId, amount) => {
    this.isLoading = true;
    this.error = null;

    const toastPromise = toast.promise(createExchangeTransactionRequest(accountNumber, { quoteId, amount }), {
      pending: i18n.getMessage('exchangeTransactionsStore.createExchange.toastPromise.pending'),
      success: i18n.getMessage('exchangeTransactionsStore.createExchange.toastPromise.success')
    });

    try {
      const newTransaction = await toastPromise;

      runInAction(() => {
        this.isNewExchangeTransactionCreated = true;
        this.newTransactionId = newTransaction.transactionNumber;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err;
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };
}

export default new ExchangeTransactionsStore();
